import { DOCUMENT } from "@angular/common";

import { Inject, Injectable } from "@angular/core";
import { Subject } from "rxjs";

@Injectable()
export class EscapeProvider {
  private dismiss$ = new Subject<HTMLElement>();
  private element: HTMLElement;

  constructor(@Inject(DOCUMENT) private document: HTMLDocument) {}

  public start$(element: HTMLElement = this.document.body) {
    this.element = element;
    this.element.addEventListener("keyup", this.dissmissPopupKeyHandler);
    this.element.addEventListener("click", this.dissmissPopupClickHandler);

    return this.dismiss$.asObservable();
  }

  public stop() {
    this.element.removeEventListener("keyup", this.dissmissPopupKeyHandler);
    this.element.removeEventListener("click", this.dissmissPopupClickHandler);
  }

  private dissmissPopupKeyHandler = (event) => {
    if (event.key === "Escape") {
      this.dismiss$.next(this.element);
    }
  };

  private dissmissPopupClickHandler = (event) => {
    this.dismiss$.next(event.target);
  };
}



// WEBPACK FOOTER //
// ./src/providers/escape/escape.ts